// Async boundary so Module Federation can resolve shared React before the app
// renders; shared modules are not eager, so they cannot be imported synchronously.
import('./bootstrap');
